import {
    GET_CONSIGNED_INVENTORY,
    GET_CONSIGNED_INVENTORY_SUCCESS,
    GET_CONSIGNED_INVENTORY_FAILURE,
    CONSIGNED_INVENTORY_EXPORT,
    CONSIGNED_INVENTORY_EXPORT_SUCCESS,
    CONSIGNED_INVENTORY_EXPORT_FAILURE,
    RESET_CONSIGNED_INVENTORY_EXPORT,
    SET_CONSIGNED_SEARCH_PARAMS,
    GET_CONSIGNED_PREFERENCE,
    GET_CONSIGNED_PREFERENCE_SUCCESS,
    GET_CONSIGNED_PREFERENCE_FAILURE,
    FETCH_FILTER_DATA,
    FETCH_FILTER_DATA_SUCCESS,
    FETCH_FILTER_DATA_FAILURE,
    SET_CONSIGNED_FILTER_DATA,
    SET_DEFAULT_TERRITORY,
    SET_CONSIGNED_SEARCHBAR_TEXT,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
    loading: false,
    inventoryData: [],
    totalResults: 0,
    loadingConsignedExport: false,
    exportData: null,
    exportError: null,
    error: null,
    searchText: '',
    searchType: '',
    preferenceData: {
        districtFilters: [],
        territoryFilters: [],
        accountFilters: [],
        brandFilters: [],
    },
    filterLoading: {
        districtFilters: false,
        territoryFilters: false,
        accountFilters: false,
        brandFilters: false,
    },
    filterError: {
        districtFilters: null,
        territoryFilters: null,
        accountFilters: null,
        brandFilters: null,
    },
    filterData: {
        districtFilters: [],
        territoryFilters: [],
        accountFilters: [],
        scopedAccountFilters: {},
        brandFilters: [],
    },
    consignedAppliedFilters: null,
    preferenceLoading: true,
    preferenceError: null,
    searchbarText: {},
};

const consignedInventoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CONSIGNED_INVENTORY:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_CONSIGNED_INVENTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                inventoryData: action.payload?.inventoryListDTO || [],
                totalResults: action.payload?.itemsNumber || 0,
                defaultTerritory: action.payload?.defaultTerritory || null,
                response: action.payload,
            };
        case GET_CONSIGNED_INVENTORY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case CONSIGNED_INVENTORY_EXPORT:
            return {
                ...state,
                loadingConsignedExport: true,
                exportError: null,
            };
        case CONSIGNED_INVENTORY_EXPORT_SUCCESS:
            return {
                ...state,
                loadingConsignedExport: false,
                exportData: action.payload,
                exportError: null,
            };
        case CONSIGNED_INVENTORY_EXPORT_FAILURE:
            return {
                ...state,
                loadingConsignedExport: false,
                exportData: null,
                exportError: action.payload?.error || action.payload,
            };
        case RESET_CONSIGNED_INVENTORY_EXPORT:
            return {
                ...state,
                loadingConsignedExport: false,
                exportData: null,
                exportError: null,
            };
        case SET_CONSIGNED_SEARCH_PARAMS:
            return {
                ...state,
                searchText: action.payload?.searchText ?? '',
                searchType: action.payload?.searchType ?? '',
            };
        case GET_CONSIGNED_PREFERENCE:
            return {
                ...state,
                preferenceLoading: true,
                preferenceError: null,
            };
        case GET_CONSIGNED_PREFERENCE_SUCCESS:
            return {
                ...state,
                preferenceLoading: false,
                preferenceData: action.payload,
            };
        case GET_CONSIGNED_PREFERENCE_FAILURE:
            return {
                ...state,
                preferenceLoading: false,
                preferenceError: action.payload,
            };
        case FETCH_FILTER_DATA:
            return {
                ...state,
                filterLoading: {
                    ...state.filterLoading,
                    [action.payload.filterKey]: true,
                },
                filterError: {
                    ...state.filterError,
                    [action.payload.filterKey]: null,
                },
            };
        case FETCH_FILTER_DATA_SUCCESS:
            if (action.payload.filterKey === 'accountFilters' && action.payload.scopeKey) {
                // scopeKey may be a single key or an array, so one response can update several scopes at once
                const scopeKeys = Array.isArray(action.payload.scopeKey) ? action.payload.scopeKey : [action.payload.scopeKey];
                return {
                    ...state,
                    filterLoading: {
                        ...state.filterLoading,
                        [action.payload.filterKey]: false,
                    },
                    filterData: {
                        ...state.filterData,
                        scopedAccountFilters: {
                            ...(state.filterData.scopedAccountFilters || {}),
                            ...Object.fromEntries(scopeKeys.map((key) => [key, action.payload.data])),
                        },
                    },
                };
            }

            return {
                ...state,
                filterLoading: {
                    ...state.filterLoading,
                    [action.payload.filterKey]: false,
                },
                filterData: {
                    ...state.filterData,
                    [action.payload.filterKey]: action.payload.data,
                },
            };
        case FETCH_FILTER_DATA_FAILURE:
            return {
                ...state,
                filterLoading: {
                    ...state.filterLoading,
                    [action.payload.filterKey]: false,
                },
                filterError: {
                    ...state.filterError,
                    [action.payload.filterKey]: action.payload.error,
                },
            };
        case SET_CONSIGNED_FILTER_DATA:
            return {
                ...state, 
                consignedAppliedFilters: {
                    ...action.payload,
                },
            };
        case SET_DEFAULT_TERRITORY:
            return {
                ...state,
                defaultTerritory: action.payload,
            };
        case SET_CONSIGNED_SEARCHBAR_TEXT:
            return {
                ...state,
                searchbarText: {
                    ...state.searchbarText,
                    [action.payload?.filterType]: action.payload?.value ?? '',
                },
            };
        default:
            return state;
    }
};

export default persistReducer(
    {
        key: 'consignedInventoryKey',
        storage: storage,
        whitelist: ['preferenceData', 'inventoryData', 'totalResults'],
    },
    consignedInventoryReducer
);